import React from 'react';

export const wrapRootElement = ({ element, ...rest }) => {
  return <>{element}</>;
};
